// PER FER SCROLL AL MAPA EN MOBILE https://github.com/elmarquis/Leaflet.GestureHandling
!function(a,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define("leafletGestureHandling",["exports"],t):t(a.leafletGestureHandling={})}(this,function(a){"use strict";var o={ar:{touch:"استخدم إصبعين لتحريك الخريطة",scroll:"‏استخدم ctrl + scroll لتصغير/تكبير الخريطة",scrollMac:"يمكنك استخدام ⌘ + التمرير لتكبير/تصغير الخريطة"},bg:{touch:"Използвайте два пръста, за да преместите картата",scroll:"Задръжте бутона Ctrl натиснат, докато превъртате, за да промените мащаба на картата",scrollMac:"Задръжте бутона ⌘ натиснат, докато превъртате, за да промените мащаба на картата"},bn:{touch:"মানচিত্রটিকে সরাতে দুটি আঙ্গুল ব্যবহার করুন",scroll:"ম্যাপ জুম করতে ctrl + scroll ব্যবহার করুন",scrollMac:"ম্যাপে জুম করতে ⌘ বোতাম টিপে স্ক্রল করুন"},ca:{touch:"Fes servir dos dits per moure el mapa",scroll:"Prem la tecla Control mentre et desplaces per apropar i allunyar el mapa",scrollMac:"Prem la tecla ⌘ mentre et desplaces per apropar i allunyar el mapa"},cs:{touch:"K posunutí mapy použijte dva prsty",scroll:"Velikost zobrazení mapy změňte podržením klávesy Ctrl a posouváním kolečka myši",scrollMac:"Velikost zobrazení mapy změníte podržením klávesy ⌘ a posunutím kolečka myši / touchpadu"},da:{touch:"Brug to fingre til at flytte kortet",scroll:"Brug ctrl + rullefunktionen til at zoome ind og ud på kortet",scrollMac:"Brug ⌘ + rullefunktionen til at zoome ind og ud på kortet"},de:{touch:"Verschieben der Karte mit zwei Fingern",scroll:"Verwende Strg+Scrollen zum Zoomen der Karte",scrollMac:"⌘"},el:{touch:"Χρησιμοποιήστε δύο δάχτυλα για μετακίνηση στον χάρτη",scroll:"Χρησιμοποιήστε το πλήκτρο Ctrl και κύλιση, για να μεγεθύνετε τον χάρτη",scrollMac:"Χρησιμοποιήστε το πλήκτρο ⌘ + κύλιση για εστίαση στον χάρτη"},en:{touch:"Use two fingers to move the map",scroll:"Use ctrl + scroll to zoom the map",scrollMac:"Use ⌘ + scroll to zoom the map"},"en-AU":{touch:"Use two fingers to move the map",scroll:"Use ctrl + scroll to zoom the map",scrollMac:"Use ⌘ + scroll to zoom the map"},"en-GB":{touch:"Use two fingers to move the map",scroll:"Use ctrl + scroll to zoom the map",scrollMac:"Use ⌘ + scroll to zoom the map"},es:{touch:"Para mover el mapa, utiliza dos dedos",scroll:"Mantén pulsada la tecla Ctrl mientras te desplazas para acercar o alejar el mapa",scrollMac:"Mantén pulsada la tecla ⌘ mientras te desplazas para acercar o alejar el mapa"},eu:{touch:"Erabili bi hatz mapa mugitzeko",scroll:"Mapan zooma aplikatzeko, sakatu Ktrl eta egin gora edo behera",scrollMac:"Eduki sakatuta ⌘ eta egin gora eta behera mapa handitu eta txikitzeko"},fa:{touch:"برای حرکت دادن نقشه از دو انگشت استفاده کنید.",scroll:"‏برای بزرگ‌نمایی نقشه از ctrl + scroll استفاده کنید",scrollMac:"برای بزرگ‌نمایی نقشه، از ⌘ + پیمایش استفاده کنید."},fi:{touch:"Siirrä karttaa kahdella sormella.",scroll:"Zoomaa karttaa painamalla Ctrl-painiketta ja vierittämällä.",scrollMac:"Zoomaa karttaa pitämällä painike ⌘ painettuna ja vierittämällä."},fil:{touch:"Gumamit ng dalawang daliri upang iusog ang mapa",scroll:"Gamitin ang ctrl + scroll upang i-zoom ang mapa",scrollMac:"Gamitin ang ⌘ + scroll upang i-zoom ang mapa"},fr:{touch:"Utilisez deux doigts pour déplacer la carte",scroll:"Vous pouvez zoomer sur la carte à l'aide de CTRL+Molette de défilement",scrollMac:"Vous pouvez zoomer sur la carte à l'aide de ⌘+Molette de défilement"},gl:{touch:"Utiliza dous dedos para mover o mapa",scroll:"Preme Ctrl mentres te desprazas para ampliar o mapa",scrollMac:"Preme ⌘ e desprázate para ampliar o mapa"},gu:{touch:"નકશો ખસેડવા બે આંગળીઓનો ઉપયોગ કરો",scroll:"નકશાને ઝૂમ કરવા માટે ctrl + સ્ક્રોલનો ઉપયોગ કરો",scrollMac:"નકશાને ઝૂમ કરવા ⌘ + સ્ક્રોલનો ઉપયોગ કરો"},hi:{touch:"मैप एक जगह से दूसरी जगह ले जाने के लिए दो उंगलियों का इस्तेमाल करें",scroll:"मैप को ज़ूम करने के लिए ctrl + स्क्रोल का उपयोग करें",scrollMac:"मैप को ज़ूम करने के लिए ⌘ + स्क्रोल का उपयोग करें"},hr:{touch:"Pomičite kartu pomoću dva prsta",scroll:"Upotrijebite Ctrl i klizač miša da biste zumirali kartu",scrollMac:"Upotrijebite gumb ⌘ dok se pomičete za zumiranje karte"},hu:{touch:"Két ujjal mozgassa a térképet",scroll:"A térkép a ctrl + görgetés használatával nagyítható",scrollMac:"A térkép a ⌘ + görgetés használatával nagyítható"},id:{touch:"Gunakan dua jari untuk menggerakkan peta",scroll:"Gunakan ctrl + scroll untuk memperbesar atau memperkecil peta",scrollMac:"Gunakan ⌘ + scroll untuk memperbesar atau memperkecil peta"},it:{touch:"Utilizza due dita per spostare la mappa",scroll:"Utilizza CTRL + scorrimento per eseguire lo zoom della mappa",scrollMac:"Utilizza ⌘ + scorrimento per eseguire lo zoom della mappa"},iw:{touch:"הזז את המפה באמצעות שתי אצבעות",scroll:"‏אפשר לשנות את מרחק התצוגה במפה באמצעות מקש ctrl וגלילה",scrollMac:"אפשר לשנות את מרחק התצוגה במפה באמצעות מקש ⌘ וגלילה"},ja:{touch:"地図を移動させるには指 2 本で操作します",scroll:"地図をズームするには、Ctrl キーを押しながらスクロールしてください",scrollMac:"地図をズームするには、⌘ キーを押しながらスクロールしてください"},kn:{touch:"Use two fingers to move the map",scroll:"Use Ctrl + scroll to zoom the map",scrollMac:"Use ⌘ + scroll to zoom the map"},ko:{touch:"지도를 움직이려면 두 손가락을 사용하세요.",scroll:"지도를 확대/축소하려면 Ctrl을 누른 채 스크롤하세요.",scrollMac:"지도를 확대하려면 ⌘ + 스크롤 사용"},lt:{touch:"Perkelkite žemėlapį dviem pirštais",scroll:"Slinkite nuspaudę klavišą „Ctrl“, kad pakeistumėte žemėlapio mastelį",scrollMac:"Paspauskite klavišą ⌘ ir slinkite, kad priartintumėte žemėlapį"},lv:{touch:"Lai pārvietotu karti, bīdiet to ar diviem pirkstiem",scroll:"Kartes tālummaiņai izmantojiet ctrl + ritināšanu",scrollMac:"Lai veiktu kartes tālummaiņu, izmantojiet ⌘ + ritināšanu"},ml:{touch:"മാപ്പ് നീക്കാൻ രണ്ട് വിരലുകൾ ഉപയോഗിക്കുക",scroll:"കൺട്രോൾ + സ്‌ക്രോൾ ഉപയോഗിച്ച് ‌മാപ്പ് ‌സൂം ചെയ്യുക",scrollMac:"⌘ + സ്‌ക്രോൾ ഉപയോഗിച്ച് ‌മാപ്പ് ‌സൂം ചെയ്യുക"},mr:{touch:"नकाशा हलविण्यासाठी दोन बोटे वापरा",scroll:"नकाशा झूम करण्यासाठी ctrl + scroll वापरा",scrollMac:"नकाशावर झूम करण्यासाठी ⌘ + स्क्रोल वापरा"},nl:{touch:"Gebruik twee vingers om de kaart te verplaatsen",scroll:"Gebruik Ctrl + scrollen om in- en uit te zoomen op de kaart",scrollMac:"Gebruik ⌘ + scrollen om in en uit te zoomen op de kaart"},no:{touch:"Bruk to fingre for å flytte kartet",scroll:"Hold ctrl-tasten inne og rull for å zoome på kartet",scrollMac:"Hold inne ⌘-tasten og rull for å zoome på kartet"},pl:{touch:"Przesuń mapę dwoma palcami",scroll:"Naciśnij CTRL i przewiń, by przybliżyć mapę",scrollMac:"Naciśnij ⌘ i przewiń, by przybliżyć mapę"},pt:{touch:"Use dois dedos para mover o mapa",scroll:"Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",scrollMac:"Use ⌘ e role a tela simultaneamente para aplicar zoom no mapa"},"pt-BR":{touch:"Use dois dedos para mover o mapa",scroll:"Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",scrollMac:"Use ⌘ e role a tela simultaneamente para aplicar zoom no mapa"},"pt-PT":{touch:"Utilize dois dedos para mover o mapa",scroll:"Utilizar ctrl + deslocar para aumentar/diminuir zoom do mapa",scrollMac:"Utilize ⌘ + deslocar para aumentar/diminuir o zoom do mapa"},ro:{touch:"Folosiți două degete pentru a deplasa harta",scroll:"Apăsați tasta ctrl și derulați simultan pentru a mări harta",scrollMac:"Folosiți ⌘ și derulați pentru a mări/micșora harta"},ru:{touch:"Чтобы переместить карту, проведите по ней двумя пальцами",scroll:"Чтобы изменить масштаб, прокручивайте карту, удерживая клавишу Ctrl.",scrollMac:"Чтобы изменить масштаб, нажмите ⌘ + прокрутка"},sk:{touch:"Mapu môžete posunúť dvoma prstami",scroll:"Ak chcete priblížiť mapu, stlačte kláves ctrl a posúvajte",scrollMac:"Ak chcete priblížiť mapu, stlačte kláves ⌘ a posúvajte kolieskom myši"},sl:{touch:"Premaknite zemljevid z dvema prstoma",scroll:"Zemljevid povečate tako, da držite tipko Ctrl in vrtite kolesce na miški",scrollMac:"Uporabite ⌘ + funkcijo pomika, da povečate ali pomanjšate zemljevid"},sr:{touch:"Мапу померајте помоћу два прста",scroll:"Притисните ctrl тастер док померате да бисте зумирали мапу",scrollMac:"Притисните тастер ⌘ док померате да бисте зумирали мапу"},sv:{touch:"Använd två fingrar för att flytta kartan",scroll:"Använd ctrl + rulla för att zooma kartan",scrollMac:"Använd ⌘ + rulla för att zooma på kartan"},ta:{touch:"மேப்பை நகர்த்த இரண்டு விரல்களைப் பயன்படுத்தவும்",scroll:"மேப்பை பெரிதாக்கி/சிறிதாக்கிப் பார்க்க, ctrl பட்டனைப் பிடித்தபடி, மேலே/கீழே ஸ்க்ரால் செய்யவும்",scrollMac:"மேப்பை பெரிதாக்கி/சிறிதாக்கிப் பார்க்க, ⌘ பட்டனைப் பிடித்தபடி, மேலே/கீழே ஸ்க்ரால் செய்யவும்"},te:{touch:"మ్యాప్‌ని తరలించడం కోసం రెండు వేళ్లను ఉపయోగించండి",scroll:"మ్యాప్‌ని జూమ్ చేయడానికి ctrl బటన్‌ను నొక్కి ఉంచి, స్క్రోల్ చేయండి",scrollMac:"మ్యాప్ జూమ్ చేయాలంటే ⌘ + స్క్రోల్ ఉపయోగించండి"},th:{touch:"ใช้ 2 นิ้วเพื่อเลื่อนแผนที่",scroll:"กด Ctrl ค้างไว้ แล้วเลื่อนหน้าจอเพื่อซูมแผนที่",scrollMac:"กด ⌘ แล้วเลื่อนหน้าจอเพื่อซูมแผนที่"},tl:{touch:"Gumamit ng dalawang daliri upang iusog ang mapa",scroll:"Gamitin ang ctrl + scroll upang i-zoom ang mapa",scrollMac:"Gamitin ang ⌘ + scroll upang i-zoom ang mapa"},tr:{touch:"Haritada gezinmek için iki parmağınızı kullanın",scroll:"Haritayı yakınlaştırmak için ctrl + kaydırma kombinasyonunu kullanın",scrollMac:"Haritayı yakınlaştırmak için ⌘ tuşuna basıp ekranı kaydırın"},uk:{touch:"Переміщуйте карту двома пальцями",scroll:"Щоб змінювати масштаб карти, прокручуйте коліщатко миші, утримуючи клавішу Ctrl",scrollMac:"Щоб змінити масштаб карти, використовуйте ⌘ + прокручування"},vi:{touch:"Sử dụng hai ngón tay để di chuyển bản đồ",scroll:"Sử dụng ctrl + cuộn để thu phóng bản đồ",scrollMac:"Sử dụng ⌘ + cuộn để thu phóng bản đồ"},"zh-CN":{touch:"使用双指移动地图",scroll:"按住 Ctrl 并滚动鼠标滚轮才可缩放地图",scrollMac:"按住 ⌘ 并滚动鼠标滚轮才可缩放地图"},"zh-TW":{touch:"同時以兩指移動地圖",scroll:"按住 ctrl 鍵加上捲動滑鼠可以縮放地圖",scrollMac:"按 ⌘ 加上滾動捲軸可以縮放地圖"}};L.Map.mergeOptions({gestureHandlingOptions:{text:{},duration:1e3}});var t=!1,e=L.Handler.extend({addHooks:function(){this._handleTouch=this._handleTouch.bind(this),this._setupPluginOptions(),this._setLanguageContent(),this._disableInteractions(),this._map._container.addEventListener("touchstart",this._handleTouch),this._map._container.addEventListener("touchmove",this._handleTouch),this._map._container.addEventListener("touchend",this._handleTouch),this._map._container.addEventListener("touchcancel",this._handleTouch),this._map._container.addEventListener("click",this._handleTouch),L.DomEvent.on(this._map._container,"mousewheel",this._handleScroll,this),L.DomEvent.on(this._map,"mouseover",this._handleMouseOver,this),L.DomEvent.on(this._map,"mouseout",this._handleMouseOut,this),L.DomEvent.on(this._map,"movestart",this._handleDragging,this),L.DomEvent.on(this._map,"move",this._handleDragging,this),L.DomEvent.on(this._map,"moveend",this._handleDragging,this)},removeHooks:function(){this._enableInteractions(),this._map._container.removeEventListener("touchstart",this._handleTouch),this._map._container.removeEventListener("touchmove",this._handleTouch),this._map._container.removeEventListener("touchend",this._handleTouch),this._map._container.removeEventListener("touchcancel",this._handleTouch),this._map._container.removeEventListener("click",this._handleTouch),L.DomEvent.off(this._map._container,"mousewheel",this._handleScroll,this),L.DomEvent.off(this._map,"mouseover",this._handleMouseOver,this),L.DomEvent.off(this._map,"mouseout",this._handleMouseOut,this),L.DomEvent.off(this._map,"movestart",this._handleDragging,this),L.DomEvent.off(this._map,"move",this._handleDragging,this),L.DomEvent.off(this._map,"moveend",this._handleDragging,this)},_handleDragging:function(a){"movestart"==a.type||"move"==a.type?t=!0:"moveend"==a.type&&(t=!1)},_disableInteractions:function(){this._map.dragging.disable(),this._map.scrollWheelZoom.disable(),this._map.tap&&this._map.tap.disable()},_enableInteractions:function(){this._map.dragging.enable(),this._map.scrollWheelZoom.enable(),this._map.tap&&this._map.tap.enable()},_setupPluginOptions:function(){this._map.options.gestureHandlingText&&(this._map.options.gestureHandlingOptions.text=this._map.options.gestureHandlingText)},_setLanguageContent:function(){var a;if(this._map.options.gestureHandlingOptions&&this._map.options.gestureHandlingOptions.text&&this._map.options.gestureHandlingOptions.text.touch&&this._map.options.gestureHandlingOptions.text.scroll&&this._map.options.gestureHandlingOptions.text.scrollMac)a=this._map.options.gestureHandlingOptions.text;else{var t=this._getUserLanguage();t||(t="en"),o[t]&&(a=o[t]),a||-1===t.indexOf("-")||(t=t.split("-")[0],a=o[t]),a||(a=o[t="en"])}var e=!1;0<=navigator.platform.toUpperCase().indexOf("MAC")&&(e=!0);var l=a.scroll;e&&(l=a.scrollMac),this._map._container.setAttribute("data-gesture-handling-touch-content",a.touch),this._map._container.setAttribute("data-gesture-handling-scroll-content",l)},_getUserLanguage:function(){return navigator.languages?navigator.languages[0]:navigator.language||navigator.userLanguage},_handleTouch:function(a){for(var t=["leaflet-control-minimap","leaflet-interactive","leaflet-popup-content","leaflet-popup-content-wrapper","leaflet-popup-close-button","leaflet-control-zoom-in","leaflet-control-zoom-out"],e=!1,l=0;l<t.length;l++)L.DomUtil.hasClass(a.target,t[l])&&(e=!0);e?L.DomUtil.hasClass(a.target,"leaflet-interactive")&&"touchmove"===a.type&&1===a.touches.length?(L.DomUtil.addClass(this._map._container,"leaflet-gesture-handling-touch-warning"),this._disableInteractions()):L.DomUtil.removeClass(this._map._container,"leaflet-gesture-handling-touch-warning"):"touchmove"===a.type||"touchstart"===a.type?1===a.touches.length?(L.DomUtil.addClass(this._map._container,"leaflet-gesture-handling-touch-warning"),this._disableInteractions()):(this._enableInteractions(),L.DomUtil.removeClass(this._map._container,"leaflet-gesture-handling-touch-warning")):L.DomUtil.removeClass(this._map._container,"leaflet-gesture-handling-touch-warning")},_isScrolling:!1,_handleScroll:function(a){a.metaKey||a.ctrlKey?(a.preventDefault(),L.DomUtil.removeClass(this._map._container,"leaflet-gesture-handling-scroll-warning"),this._map.scrollWheelZoom.enable()):(L.DomUtil.addClass(this._map._container,"leaflet-gesture-handling-scroll-warning"),this._map.scrollWheelZoom.disable(),clearTimeout(this._isScrolling),this._isScrolling=setTimeout(function(){for(var a=document.getElementsByClassName("leaflet-gesture-handling-scroll-warning"),t=0;t<a.length;t++)L.DomUtil.removeClass(a[t],"leaflet-gesture-handling-scroll-warning")},this._map.options.gestureHandlingOptions.duration))},_handleMouseOver:function(a){this._enableInteractions()},_handleMouseOut:function(a){t||this._disableInteractions()}});L.Map.addInitHook("addHandler","gestureHandling",e),a.GestureHandling=e,a.default=e,Object.defineProperty(a,"__esModule",{value:!0})});
//# sourceMappingURL=leaflet-gesture-handling.min.js.map

var MapScript = (function ($) {

    var Init = function () {

        // INIT VARS ///////////////////////////////////////////////////////////////
        var original_zoom = 8;
        var map_fit_bounds = false;
        var currentLoc = [41.6909844, 1.9472658];
        var zoom;
        var use_cluster = true;
        var is_global = false;
        var filtered = false;
        hot_treshold = 1;
        var MAX_POINTS_SORTED = 6;
        // Only show active vehicles
        var only_active = show_only_active();
        var creation_map = false; //Quan es crea el mapa o s'aplica un filtre

        var parking_distance_sorted = {};

        var markers = [];
        var hot_parkings = [];
        var working_parkings = [];
        var in_process_parkings = [];
        var planned_parkings = [];
        var nearest_markers = [];
        var map_mode = 'all';
        var window_mode = 'show';

        var parkings = false;


        var cluster = L.markerClusterGroup({
            iconCreateFunction: function (cluster) {
                var markers = cluster.getAllChildMarkers();
                return L.divIcon({html: markers.length, className: 'sm-cluster', iconSize: L.point(40, 40)});
            },
            spiderfyOnMaxZoom: false,
            showCoverageOnHover: false,
            zoomToBoundsOnClick: true
        });


        if ($('.parkings_map_section').data('maplat') != '') {
            currentLoc[0] = parseFloat($('.parkings_map_section').data('maplat'));
        }
        if ($('.parkings_map_section').data('maplng') != '') {
            currentLoc[1] = parseFloat($('.parkings_map_section').data('maplng'));
        }
        if ($('.parkings_map_section').data('mapzoom') != '') {
            zoom_txt = $('.parkings_map_section').data('mapzoom');
            zoom = parseFloat(zoom_txt);
        } else {
            zoom = original_zoom;
            map_fit_bounds = true;
        }
        if ($('.parkings_map_section').data('global')) {
            is_global = true;
        }
        var greenIcon = new L.Icon({
            iconUrl: main_data.template_dist_images_uri + 'icon_parking_green.png?v=2',
            iconSize: [40, 42],
            iconAnchor: [40, 42],
            popupAnchor: [1, -34],
        });

        var yellowIcon = new L.Icon({
            iconUrl: main_data.template_dist_images_uri + 'icon_parking_yellow.png?v=2',
            iconSize: [40, 42],
            iconAnchor: [40, 42],
            popupAnchor: [1, -34],
        });

        var blueIcon = new L.Icon({
            iconUrl: main_data.template_dist_images_uri + 'icon_parking_blue.png?v=2',
            iconSize: [40, 42],
            iconAnchor: [40, 42],
            popupAnchor: [1, -34],
        });

        var map;

        init_map();

        function init_map() {

            var screenSize = $(window).width();   // returns height of browser viewport
            // INIT MAP ////////////////////////////////////////////////////////////////
            if (screenSize < 768) {
                zoom = 7; //Quals min zoom when is a mobile screen
            }
            map = L.map('map', {
                scrollWheelZoom: false,
                gestureHandling: true,
                gestureHandlingOptions: {
                    text: {
                        touch: "Fes servir dos dits per fer scroll al mapa.",
                        scroll: "Fes servir ctrl + scroll per fer zoom",
                        scrollMac: "Hey bro, use \u2318 + scroll to zoom the map"
                    }
                }
            }).setView(currentLoc, zoom);
            // L.tileLayer('http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
                // subdomains: 'abcd',
                minZoom: 7,
                maxZoom: 18,
                // variant: 'toner',
                accessToken: main_data.mapbox_api,
                // ext: 'png'
            }).addTo(map);
            //map.setZoom(zoom);
            creation_map = true;
            ////////////////////////////////////////////////////////////////////////////

            // GOOGLE MAPS & SEARCH TEXT BAR ///////////////////////////////////////////
            if (!only_active)
                google.maps.event.addDomListener(window, 'load', init_googlemaps);
            $("#searchParking").click(function () {
                selectFirstResult();
            });
            $("#locationTextField").focusin(function () {
                $(document).keyup(function (e) {
                    if (e.which == 13) {
                        selectFirstResult();
                        e.preventDefault();
                        return false;
                    }
                });
            });
        }

        $(document).on("click", ".parking-form-button", function () {
            $("select[name='fld_1767499']").val($(this).data('sel-val'));
            $('select[name="fld_1767499"] option:not(:selected)').hide();
        });


        // Router
        router = new Navigo(null, true, '#');
        router.on({
            ':parking_slug': function (params) {
                for (i = 0; i < parkings.length; ++i) {
                    if (parkings[i].name == params.parking_slug) {
                        renderSelection([parkings[i]], '.search_results_title');
                        $.scrollTo($('#toMap'), {
                            axis: 'y',
                            // duration: 800,
                            // offset: {
                            //     'top': -120
                            // }
                        });
                    }
                }
            }
        });
        ////////////////////////////////////////////////////////////////////////////

        // GET PARKINGS DB /////////////////////////////////////////////////////////

        $.ajax({
            url: main_data.ajax_url,
            type: 'get',
            data: {
                'action': 'getparkings'
            },
            success: function (response) {
                parkings = response.data.parkings;
                for (var i = 0; i < parkings.length; ++i) {
                    var position = parkings[i].position.split(",");
                    parkings[i].position = position;
                    if (parseInt(parkings[i].monthly_achieved) >= parseInt(parkings[i].monthly_objective)) {
                        hot_parkings.push(parkings[i]);
                    }
                    if (parkings[i].working == 1) {
                        working_parkings.push(parkings[i]);
                    } else if ((parkings[i].working == 0 || parkings[i].working == null) && parseInt(parkings[i].monthly_achieved) > 0) {
                        in_process_parkings.push(parkings[i]);
                    } else
                        planned_parkings.push(parkings[i]);

                    /*
                    hpk = parkings[i].monthly_achieved/parkings[i].monthly_objective;
                    if(hpk*100 > hot_treshold){
                      hot_parkings[hpk]=parkings[i];
                    }
                    */
                }
                if (!is_global) searchFound(currentLoc[0], currentLoc[1]);
                else if (only_active) {
                    filtered = true;
                    putMarkers(working_parkings, true);
                } else
                    putMarkers(parkings, true);
                router.resolve();
            },
            dataType: "json"
        });
        ////////////////////////////////////////////////////////////////////////////


        // QUICK FILTERS ///////////////////////////////////////////////////////////
        $(".js-map-filter").on('click', function (e) {
            $(this).toggleClass("map-filter-bb");
            var filterActive = $("#map-active");
            var filterInProgress = $("#map-in-progress");
            var filterPlanned = $("#map-planned");
            var jsActive = filterActive.hasClass("map-filter-bb");
            var jsInProgress$ = filterInProgress.hasClass("map-filter-bb");
            var jsPlanned = filterPlanned.hasClass("map-filter-bb");

            var parkingFiltered = [];
            var mapFiltered = false;

            filterActive.removeClass("bg-color-map-green");
            filterInProgress.removeClass("bg-color-map-orange");
            filterPlanned.removeClass("bg-color-map-yellow");
            if (jsActive) {
                filterActive.addClass("bg-color-map-green");
                parkingFiltered = parkingFiltered.concat(working_parkings);
                mapFiltered = true;
            }
            if (jsInProgress$) {
                filterInProgress.addClass("bg-color-map-orange");
                parkingFiltered = parkingFiltered.concat(in_process_parkings);
                mapFiltered = true;
            }
            if (jsPlanned) {
                filterPlanned.addClass("bg-color-map-yellow");
                parkingFiltered = parkingFiltered.concat(planned_parkings);
                mapFiltered = true;
            }

            //rewriteMap();
            //init_map();
            creation_map = true;
            if ((jsActive && jsInProgress$ && jsPlanned) || (!jsActive && !jsInProgress$ && !jsPlanned)) {
                filtered = false;
                verify_cluster(true);
            } else {
                filtered = true;
                verify_cluster(true);
            }
            if (mapFiltered)
                putMarkers(parkingFiltered, true);
            else
                putMarkers(parkings, true);
        });

        $('.js-pkHotFilter').on('click', function (e) {
            e.preventDefault();
            if (map_mode != 'hot') {
                renderSelection(hot_parkings, '.search_hot_results_title');
                map_mode = 'hot';
            }
        });
        $('.js-pkCompletedFilter').on('click', function (e) {
            e.preventDefault();
            if (map_mode != 'completed') {
                renderSelection(working_parkings, '.search_completed_results_title');
                map_mode = 'completed';
            }
        });
        ////////////////////////////////////////////////////////////////////////////

        // SEARCH RESULTS///////////////////////////////////////////////////////////
        function searchFound(lat, lng) {
            currentLoc[0] = lat;
            currentLoc[1] = lng;
            // Remove classes from filter
            $("#map-active").removeClass("map-filter-bb");
            $("#map-in-progress").removeClass("map-filter-bb");
            $("#map-planned").removeClass("map-filter-bb");
            $("#map-active").removeClass("bg-color-map-green");
            $("#map-in-progress").removeClass("bg-color-map-orange");
            $("#map-planned").removeClass("bg-color-map-yellow");
            verify_cluster(true);
            filtered = false;
            var near_markers = putMarkers(parkings, false);
            // near_group = new L.featureGroup(near_markers);
            // map.fitBounds(near_group.getBounds());
            renderSearchResults();
        }

        function renderSearchResults() {
            $('#searchResults').html('');
            $('.search_hot_results_title').hide();
            $('.search_completed_results_title').hide();
            $('.search_results_title').hide();
            for (var i = 0; i < MAX_POINTS_SORTED; i++) {
                var params = parking_params(parkings[parking_distance_sorted[i].parking_aray_num]);
                params.row_class = 'col-sm-6 col-md-4';
                //if (i % 2 == 0) params.row_class += ' clear-2';
                //if (i % 3 == 0) params.row_class += ' clear-3';
                var box = renderBox(params, true);
                $('#searchResults').append(box);
            }
            $('.search_results_title').show();
            $('#searchResults').show();
        }

        function renderSelection(parkings, title_type) {
            var featured = [];
            $('#searchResults').html('');
            $('.search_hot_results_title').hide();
            $('.search_completed_results_title').hide();
            $('.search_results_title').hide();
            if (parkings.length > 0) {
                for (var i = 0; i < parkings.length; i++) {
                    // hpk = sorted[i].monthly_achieved/sorted[i].monthly_objective;
                    // if(hpk*100 < 100){
                    var params = parking_params(parkings[i]);
                    params.row_class = 'col-sm-6 col-md-4';
                    // if( i%2 == 0 ) params.row_class += ' clear-2';
                    // if( i%3 == 0 ) params.row_class += ' clear-3';
                    var box = renderBox(params, true);
                    $('#searchResults').append(box);
                    for (var j = 0; j < markers.length; ++j) {
                        if (markers[j].options.p_id == parkings[i].id) {
                            featured[featured.length] = markers[j];
                        }
                    }
                    // }
                }
                $(title_type).show();
                $('#searchResults').show();
                var markers_group = new L.featureGroup(featured);
                map.fitBounds(markers_group.getBounds());
                // map.setZoom(map.getZoom()-1);
                // if(parkings.length == 1){
                //   featured[0].fire( "click" );
                // }
            }

        }

        function putMarkers(aparcaments, show_all) {
            markers = [];
            var params = {};
            var box = "";
            aparcaments.sort(function (b, a) {
                return parseInt(a.monthly_achieved) / parseInt(a.monthly_objective) - parseInt(b.monthly_achieved) / parseInt(b.monthly_objective);
            });
            $('#parkingsList').html('');
            for (var i = 0; i < aparcaments.length; ++i) {
                var percent = 100 * parseInt(aparcaments[i].monthly_achieved) / parseInt(aparcaments[i].monthly_objective);
                percent = Math.round(percent * 100) / 100;
                if (percent < 80) break;
                var loc = aparcaments[i].position[0] + ',' + aparcaments[i].position[1];
                $('#parkingsList').append('<li><a id="' + aparcaments[i].name + '">' + aparcaments[i].title + '</a>: ' + percent + '% complet<br/></li>');
                $("#" + aparcaments[i].name).data("lat", parseFloat(aparcaments[i].position[0]));
                $("#" + aparcaments[i].name).data("lng", parseFloat(aparcaments[i].position[1]));
                $("#" + aparcaments[i].name).on('click', function () {
                    searchFound($(this).data().lat, $(this).data().lng);
                });
            }
            nearest_markers = [];
            if (show_all) {
                for (i = 0; i < aparcaments.length; ++i) {
                    var parking = aparcaments[i];
                    var percent_n = parking.monthly_achieved / parking.monthly_objective;
                    if (percent_n > 0 && percent_n < 0.01)
                        percent_n = 0.01; //perquè mostri l'icona en process
                    if (parking.working == 1) markers[i] = L.marker(parking.position, {
                        icon: blueIcon,
                        p_id: parking.id
                    });
                    // else if (percent_n*100 >= 100) markers[i] = L.marker(parking.position, {icon: yellowIcon,p_id:parking.id});
                    else if (percent_n * 100 >= hot_treshold) markers[i] = L.marker(parking.position, {
                        icon: greenIcon,
                        p_id: parking.id
                    });
                    else markers[i] = L.marker(parking.position, {icon: yellowIcon, p_id: parking.id});
                    params = parking_params(parking);
                    box = renderBox(params, true);
                    markers[i].bindPopup(box, {minWidth: 212});
                    nearest_markers[nearest_markers.length] = markers[i];
                    if (use_cluster) {
                        cluster.clearLayers();
                        cluster.addLayer(markers[i]);
                    } else {
                        markers[i].addTo(map);
                    }
                }
                if (use_cluster) {
                    map.addLayer(cluster);
                }
            } else {
                if (use_cluster)
                    cluster.clearLayers();
                for (i = 0; i < markers.length; ++i) {
                    if (markers[i] != null) {
                        if (use_cluster) {
                            cluster.removeLayer(markers[i]);
                        } else {
                            map.removeLayer(markers[i]);
                        }
                    }
                }

                parking_distance_sorted = [];
                for (i = 0; i < aparcaments.length; ++i) {
                    var dist = distance(aparcaments[i].position);
                    var park_obj = {parking_aray_num: i, distance: dist};
                    parking_distance_sorted.push(park_obj);
                }

                parking_distance_sorted.sort(function (a, b) {
                    return a.distance - b.distance;
                });


                for (i = 0; i < aparcaments.length; ++i) {
                    var parking_i = aparcaments[i];
                    var percent_i = parking_i.monthly_achieved / parking_i.monthly_objective;
                    if (percent_i > 0 && percent_i < 0.01)
                        percent_i = 0.01; //perquè mostri l'icona en process
                    var is_near = false;
                    var added = false;
                    if (parking_i.working == 1) markers[i] = L.marker(parking_i.position, {
                        icon: blueIcon,
                        p_id: parking_i.id
                    });
                    // else if (percent_i*100 >= 100) markers[i] = L.marker(parking_i.position, {icon: yellowIcon,p_id:parking_i.id});
                    else if (percent_i * 100 >= hot_treshold) markers[i] = L.marker(parking_i.position, {
                        icon: greenIcon,
                        p_id: parking_i.id
                    });
                    else markers[i] = L.marker(parking_i.position, {icon: yellowIcon, p_id: parking_i.id});

                    for (var j = 0; j < MAX_POINTS_SORTED; ++j) {
                        if (parking_i.id == aparcaments[parking_distance_sorted[j].parking_aray_num].id) {
                            nearest_markers[nearest_markers.length] = markers[i];
                        }
                    }
                    /*for (var j=0; j<nearest.length; ++j){
                      if (parking_i.id == nearest[j][1].id){
                        nearest_markers[nearest_markers.length] = markers[i];
                      }
                    }*/
                    params = parking_params(parking_i);
                    box = renderBox(params, true);
                    markers[i].bindPopup(box, {minWidth: 212});
                    if (use_cluster) {
                        cluster.addLayer(markers[i]);
                    } else {
                        markers[i].addTo(map);
                    }
                }
                if (use_cluster) {
                    map.addLayer(cluster);
                }
            }
            markers_group = new L.featureGroup(nearest_markers);

            if (map_fit_bounds || show_all == false) {
                if (!creation_map)
                    map.fitBounds(markers_group.getBounds());
                // if (use_cluster && !filtered)
                //     verify_cluster(false);
                // else
                //     verify_cluster(false);

            }
            verify_cluster(false);
            creation_map = false;
        }

        ////////////////////////////////////////////////////////////////////////////


        function init_googlemaps() {
            var input = document.getElementById('locationTextField');
            var options = {
                componentRestrictions: {country: 'es'}
            };
            var autocomplete = new google.maps.places.Autocomplete(input, options);
            google.maps.event.addListener(autocomplete, 'place_changed', function () {
                var place = autocomplete.getPlace();
                if (place.geometry == null) {
                    var firstValue = $(".pac-container .pac-item:first").text();
                    $("#locationTextField").val(firstValue);
                } else {
                    var lat = place.geometry.location.lat();
                    var lng = place.geometry.location.lng();
                    searchFound(lat, lng);
                }
            });
        }

        function selectFirstResult() {
            $(".pac-container").hide();
            var firstResult = $(".pac-container .pac-item:first").text();

            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({"address": firstResult}, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var lat = results[0].geometry.location.lat();
                    var lng = results[0].geometry.location.lng();
                    searchFound(lat, lng);
                }
            });
        }

        ////////////////////////////////////////////////////////////////////////////

        // MAP EVENTS //////////////////////////////////////////////////////////////
        map.on('zoom', function (event) {
            verify_cluster(false);
        });
        map.on('popupopen', function (e) {
            var px = map.project(e.popup._latlng); // find the pixel location on the map where the popup anchor is
            px.y -= e.popup._container.clientHeight / 1.6; // find the height of the popup container, divide by 2, subtract from the Y axis of marker location
            map.panTo(map.unproject(px), {animate: true}); // pan to new center
        });
        ////////////////////////////////////////////////////////////////////////////
        // UTILS ///////////////////////////////////////////////////////////////////

        function verify_cluster(clear) {
            if (map.getZoom() <= 9 && !filtered) {
                use_cluster = true;
                for (i = 0; i < markers.length; ++i) {
                    if (markers[i] != null) {
                        map.removeLayer(markers[i]);
                        cluster.addLayer(markers[i]);
                    }
                }
                map.addLayer(cluster);
            } else {
                use_cluster = false;
                for (i = 0; i < markers.length; ++i) {
                    if (markers[i] != null) {
                        cluster.removeLayer(markers[i]);
                        map.addLayer(markers[i]);
                    }
                }
                map.removeLayer(cluster);
            }
            if (clear) {
                for (i = 0; i < markers.length; ++i) {
                    if (markers[i] != null) {
                        map.removeLayer(markers[i]);
                        //cluster.addLayer(markers[i]);
                    }
                }
            }
        }

        function ksort(obj) {
            var keys = Object.keys(obj).sort();
            var sortedObj = [];
            var j = 0;
            for (var i in keys) {
                sortedObj[j] = obj[keys[i]];
                j++;
            }

            return sortedObj;
        }

        function parking_params(parking) {
            var working_bool = false;
            if (parking.working == "1")
                working_bool = true;
            return {
                'id': parking.id,
                'name': parking.name,
                'title': parking.title,
                'address': parking.address,
                'vehicle_address_link': parking.vehicle_address_link,
                'parking_status': parking.parking_status,
                'not_working': !parking.working,
                'working': parking.working,
                'working_bool': working_bool,
                'num_vehicles': parking.num_vehicles,
                'monthly_achieved': parking.monthly_achieved,
                'monthly_objective': parking.monthly_objective
            };
        }

        // Mustache rendering
        function renderBox(data, full) {
            var percent = (100 * data.monthly_achieved / data.monthly_objective);
            if (percent > 0 && percent < 1)
                percent = 1; //perquè mostri l'icona en process
            percent = parseInt(percent);
            data.percent = percent;
            data.full = full;
            data.minimal = !full;
            if (data.working == 1) data.icon = main_data.template_dist_images_uri + 'icon_parking_blue.png?v=2';
            // else if (percent >= 100) data.icon = main_data.template_dist_images_uri+'icon_parking_yellow.png';
            else if (percent >= hot_treshold) data.icon = main_data.template_dist_images_uri + 'icon_parking_green.png?v=2';
            else data.icon = main_data.template_dist_images_uri + 'icon_parking_yellow.png?v=2';
            var templateBox = $('#templateBox').html();
            var box = Mustache.render(templateBox, data);
            return box;
        }

        // Distance
        function distance(loc) {
            return getDistanceFromLatLonInKm(loc[0], loc[1], currentLoc[0], currentLoc[1]);
        }

        function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
            var R = 6371; // Radius of the earth in km
            var dLat = deg2rad(lat2 - lat1);  // deg2rad below
            var dLon = deg2rad(lon2 - lon1);
            var a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c; // Distance in km
            return d;
        }

        function deg2rad(deg) {
            return deg * (Math.PI / 180);
        }

        ////////////////////////////////////////////////////////////////////////////
        function clear_map() {
            if (map) {
                verify_cluster(true);
                map.off();
                map.remove();
            }
        }

        function show_only_active() {
            // CHeck if filters are shown, that means the map is showing all vehicles;
            return !$("#map").attr('data-onlyactive');
        }
    };

    // "public" methods
    return {
        Init: Init
    };

})(jQuery);
